"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createColorManager = function (grey, accent) {
    var r = grey[0], g = grey[1], b = grey[2];
    var avg = Math.round((r + g + b) / 3);
    var isLight = avg > 127;
    var contrast = isLight ? [0, 0, 0] : [255, 255, 255];
    return {
        isLight: isLight,
        avg: avg,
        grey: grey,
        accent: accent,
        shade: function (value) {
            var base = isLight ? '0' : '255';
            return "rgba(" + base + "," + base + "," + base + "," + value + ")";
        },
        shift: function (value, opacity) {
            if (opacity === void 0) { opacity = 1; }
            var r1 = Math.max(0, Math.min(255, r + (isLight ? value : -value)));
            var g1 = Math.max(0, Math.min(255, g + (isLight ? value : -value)));
            var b1 = Math.max(0, Math.min(255, b + (isLight ? value : -value)));
            return opacity === 1 ? "rgba(" + r1 + "," + g1 + "," + b1 + "," + opacity + ")" : "rgb(" + r1 + "," + g1 + "," + b1 + ")";
        },
        contrast: function (opacity) {
            if (opacity === void 0) { opacity = 1; }
            return "rgba(" + contrast[0] + "," + contrast[1] + "," + contrast[2] + "," + opacity + ")";
        },
    };
};
exports.default = createColorManager;
